// Restaura a posição do cursor
export const restoreposicaoCursor = (element, targetPosition) => {
  const selection = window.getSelection();
  const range = document.createRange();
  
  let currentPosition = 0;
  let found = false;
  
  const processNode = (node) => {
    if (found) return;
    
    // Se é um elemento de menção
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute?.('data-mention-text')) {
      const mentionLength = node.getAttribute('data-mention-text').length;
      
      if (currentPosition + mentionLength >= targetPosition) {
        // Cursor está dentro ou no final da menção - colocar após ela
        range.setStartAfter(node);
        range.collapse(true);
        found = true;
        return;
      }
      
      currentPosition += mentionLength;
      return; // Não processar filhos
    }
    
    // Se é um nó de texto
    if (node.nodeType === Node.TEXT_NODE) {
      // Remover zero-width spaces para cálculo, mas manter no DOM
      const cleanText = node.textContent.replace(/\u200B/g, '');
      const cleanLength = cleanText.length;
      
      if (currentPosition + cleanLength >= targetPosition) {
        // Encontrou a posição - calcular offset real considerando zero-width spaces
        const offsetInCleanText = targetPosition - currentPosition;
        
        // Converter offset do texto limpo para offset real no DOM
        let realOffset = 0;
        let cleanOffset = 0;
        for (let i = 0; i < node.textContent.length && cleanOffset < offsetInCleanText; i++) {
          if (node.textContent[i] !== '\u200B') {
            cleanOffset++;
          }
          realOffset++;
        }
        
        range.setStart(node, realOffset);
        range.collapse(true);
        found = true;
        return;
      }
      
      currentPosition += cleanLength;
      return;
    }
    
    // Processar filhos recursivamente
    if (node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        processNode(node.childNodes[i]);
        if (found) break;
      }
    }
  };
  
  // Processar todos os filhos do elemento
  for (let i = 0; i < element.childNodes.length; i++) {
    processNode(element.childNodes[i]);
    if (found) break;
  }
  
  if (found) {
    selection.removeAllRanges();
    selection.addRange(range);
  } else {
    // Se não encontrou, colocar no final
    range.selectNodeContents(element);
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  }
};

// Calcula a posição do cursor no texto completo
export const calculaPosicaoCursor = (element, range) => {
  let posicaoCursor = 0;
  let found = false;
  
  const calculaPosicaoCursorInterno = (node) => {
    if (found) return;
    
    // quando (se) achar o cursor conta até o offset(qtde caracteres do inicio do nó de texto até a posição do cursor)
    if (node === range.startContainer) {
      // textUpToCursor é a parte de textodo nó até onde esta o cursor
      const textUpToCursor = node.textContent.substring(0, range.startOffset);
      posicaoCursor += textUpToCursor.replace(/\u200B/g, '').length;
      found = true;
      return;
    }
    
    // Se é um elemento de menção, contar o texto formatado
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute?.('data-mention-text')) {
      posicaoCursor += node.getAttribute('data-mention-text').length;
      return;
    }
    
    // ve se o nó não é tag de html e se tem só texto e remove espaços pra nao contar como caracter
    if (node.nodeType === Node.TEXT_NODE) {
      posicaoCursor += node.textContent.replace(/\u200B/g, '').length;
      return;
    }
    
    // Processar filhos, é recursivo
    if (node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        calculaPosicaoCursorInterno(node.childNodes[i]);
        if (found) break;
      }
    }
  };
  
  // Percorrer os filhos do editor
  for (let i = 0; i < element.childNodes.length; i++) {
    calculaPosicaoCursorInterno(element.childNodes[i]);
    if (found) break;
  }
  
  return found ? posicaoCursor : -1;
};

// Obtém o texto antes do cursor
export const getTextBeforeCursor = () => {
  const selection = window.getSelection();
  if (!selection.rangeCount) return null;
  
  const range = selection.getRangeAt(0);
  const textNode = range.startContainer;
  
  if (textNode.nodeType === Node.TEXT_NODE) {
    const text = textNode.textContent;
    const cursorPos = range.startOffset;
    return { text: text.substring(0, cursorPos), range, textNode, cursorPos };
  }
  
  return null;
};

